import {
  EMPLOYMENT_OPTIONS,
  MATCHES_ORGANISATIONS_OPTIONS
} from '../../utils/constants';
import { novatedThemes } from 'ecx.saigon.ui.common';

export default {
  data: {
    getUserProfile: {
      profile: {
        companyName: 'Eclipx',
        companyEmail: 'emilio.villante@eclipx.com',
        postcode: 2039,
        contactNumber: '+61431737234',
        noCorporateEmail: false,
        matchesOrganisations: MATCHES_ORGANISATIONS_OPTIONS.multiple
      },
      hasOrganisation: false,
      entity: novatedThemes.fleetChoice.value,
      permissions: [],
      features: {}
    },
    profileSave: {
      companyName: 'Eclipx',
      companyEmail: 'emilio.villante@eclipx.com',
      postcode: 2039,
      contactNumber: '+61431737234',
      noCorporateEmail: false
    },
    getUserOrganisations: {
      status: 'success',
      organisations: [
        {
          orgId: 'org1',
          organisation: 'organisation 1'
        },
        {
          orgId: 'org2',
          organisation: 'organisation 2'
        }
      ]
    },
    updateUserOrganisation: {
      status: 'organisationUpdated'
    }
  }
};
